import Table from './table';
import { filterData as tiposFiltroTabela } from './tableFilterHandler';

export default Table;
export { tiposFiltroTabela };
